import { httpInstance } from '@/services/httpInstance';

const createFeeService = async (dataParam) => {
  let res;
  const endpoint = '/fares/v1/fees';
  const feesSent = {};
  feesSent.description_fee = dataParam.fees_documents_list[0].description;
  feesSent.transaction_code = dataParam.transaction_code;
  feesSent.transaction_name = dataParam.transaction_name;
  feesSent.fees = dataParam.fees_documents_list;

  // Data transformation
  await httpInstance.post(
    endpoint,
    feesSent,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default createFeeService;
